import { DOCUMENT } from '@angular/common';
import {
  ApplicationRef,
  ComponentRef,
  EnvironmentInjector,
  InjectionToken,
  createComponent,
  inject,
  makeEnvironmentProviders,
  provideEnvironmentInitializer,
} from '@angular/core';
import { ToastsContainerComponent } from './toasts-container.component';

export const APP_TOASTS_OVERLAY = new InjectionToken<
  ComponentRef<ToastsContainerComponent>
>('APP_TOASTS_OVERLAY');

export function provideToastsOverlay() {
  return makeEnvironmentProviders([
    {
      provide: APP_TOASTS_OVERLAY,
      useFactory: () => {
        const appRef = inject(ApplicationRef);
        const env = inject(EnvironmentInjector);
        const doc = inject(DOCUMENT);

        const host = doc.createElement('div');
        host.className = 'toast-portal position-fixed top-0 end-0 p-3';
        host.style.zIndex = '3000';
        doc.body.appendChild(host);

        const cmpRef = createComponent(ToastsContainerComponent, {
          environmentInjector: env,
          hostElement: host,
        });
        appRef.attachView(cmpRef.hostView);
        return cmpRef;
      },
    },
    provideEnvironmentInitializer(() => {
      inject(APP_TOASTS_OVERLAY);
    }),
  ]);
}
